import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled", "id", "name"]
const _hoisted_2 = ["value", "disabled", "id"]
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}

import { PropType, ref, watch } from 'vue';
import { useIdGenerator } from '@/shared/designsystem/useIdGenerator';
import { useVModel } from '@vueuse/core';

export type NRadioButton = {
  label: string;
  value: string | number;
  disabled?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-radio-buttons',
},
  __name: 'radio-button',
  props: {
  id: {
    type: String,
  },
  label: {
    type: String,
  },
  name: {
    type: String,
  },
  modelValue: {
    type: [String, Number],
    required: true,
  },
  options: {
    type: Array as PropType<NRadioButton[]>,
    required: true,
  },
  errorMessage: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  hideLabel: {
    type: String,
  },
},
  emits: ["update:modelValue", "change"],
  setup(__props, { emit: __emit }) {



const props = __props;

const { inputId } = useIdGenerator(props.id);

const emit = __emit;

const selected = useVModel(props, 'modelValue', emit);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["n-input", { 'has-error': __props.errorMessage }])
  }, [
    _createElementVNode("fieldset", {
      disabled: __props.disabled,
      id: _unref(inputId),
      name: __props.name,
      class: "radio-button-group"
    }, [
      _createElementVNode("legend", {
        class: _normalizeClass({ 'sr-only': __props.hideLabel })
      }, _toDisplayString(__props.label), 3),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "radio-button",
          key: option.label
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            value: option.value,
            disabled: option.disabled,
            id: `${_unref(inputId)}__${index}`,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null))
          }, null, 8, _hoisted_2), [
            [_vModelRadio, _unref(selected)]
          ]),
          _createElementVNode("label", {
            class: _normalizeClass(["radio-button__label", {
            'radio-button__label--checked': _unref(selected) === option.value,
            'radio-button__label--disabled': option.disabled || __props.disabled,
          }]),
            for: `${_unref(inputId)}__${index}`
          }, _toDisplayString(option.label), 11, _hoisted_3)
        ]))
      }), 128))
    ], 8, _hoisted_1),
    (__props.errorMessage)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.errorMessage), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})